import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HelmetComponent from "../../Components/HelmetComponent";
function TermsConditions() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Terms and Conditions"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 className="main-pp-title">{t("Terms and Conditions")}</h1>

                <div class="rte">
                  <h4>OVERVIEW</h4>

                  <p>
                    This website is operated by Luxura Cart Ecommerce Private Limited (“Luxura Cart”, “we”, “us”,
                    or “our”). Throughout the site, these terms refer to Luxura Cart Ecommerce Private Limited.
                  </p>

                  <p>
                    Luxura Cart offers this website, including all information, tools, and services available from
                    this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and
                    notices stated here.
                  </p>

                  <p>
                    By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to
                    be bound by these Terms and Conditions (“Terms of Service”, “Terms”), including any additional terms
                    and policies referenced herein and/or available by hyperlink. These Terms apply to all users of the
                    site, including but not limited to browsers, vendors, customers, merchants, and contributors of
                    content.
                  </p>

                  <p>
                    Please read these Terms of Service carefully before accessing or using our website. By accessing or
                    using any part of the site, you agree to be bound by these Terms. If you do not agree to all the
                    terms and conditions in this agreement, you may not access the website or use any services.
                  </p>

                  <p>
                    Any new features or tools added to the current store will also be subject to these Terms of Service.
                    We reserve the right to update, change, or replace any part of these Terms by posting updates and/or
                    changes to our website. Your continued use of the website constitutes acceptance of those changes.
                  </p>

                  <p>
                    Our website is a custom-built platform, crafted with meticulous attention to detail so that shoppers
                    in India can access a world-class selection of imported products.
                  </p>

                  <h4>SECTION 1 – ONLINE STORE TERMS</h4>

                  <p>
                    By agreeing to these Terms of Service, you represent that you are at least the age of majority in
                    your place of residence.
                  </p>

                  <p>
                    You may not use our products for any illegal or unauthorized purpose or violate any laws in your
                    jurisdiction.
                  </p>

                  <p>You must not transmit any worms, viruses, or any code of a destructive nature.</p>

                  <p>A breach of these Terms will result in immediate termination of your access to the Services.</p>

                  <h4>SECTION 2 – GENERAL CONDITIONS</h4>

                  <p>We reserve the right to refuse service to anyone for any reason at any time.</p>

                  <p>
                    Your content (excluding credit card information) may be transferred unencrypted over various
                    networks. Credit card information is always encrypted.
                  </p>

                  <p>
                    You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service
                    without express written permission from us.
                  </p>

                  <h4>SECTION 3 – ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h4>

                  <p>
                    We are not responsible if information on this site is inaccurate, incomplete, or outdated. Any
                    reliance on the material on this site is at your own risk.
                  </p>

                  <h4>SECTION 4 – MODIFICATIONS TO THE SERVICE AND PRICES</h4>

                  <p>Prices for our products are subject to change without notice.</p>

                  <p>We reserve the right to modify or discontinue the Service at any time without notice.</p>

                  <h4>SECTION 5 – PRODUCTS OR SERVICES</h4>

                  <p>Certain products or services may be available exclusively online and in limited quantities.</p>

                  <p>We do not guarantee that product images or colors will be accurately displayed on your device.</p>

                  <h4>SECTION 6 – ACCURACY OF BILLING AND ACCOUNT INFORMATION</h4>

                  <p>
                    We reserve the right to refuse or cancel any order. You agree to provide accurate and current
                    account and billing information.
                  </p>

                  <h4>SECTION 7 – OPTIONAL TOOLS</h4>

                  <p>We may provide access to third-party tools “as is” without warranties or endorsements.</p>

                  <h4>SECTION 8 – THIRD-PARTY LINKS</h4>

                  <p>We are not responsible for third-party websites, content, or transactions.</p>

                  <h4>SECTION 9 – USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</h4>

                  <p>You agree that we may use any comments you submit without restriction or compensation.</p>

                  <h4>SECTION 10 – PERSONAL INFORMATION</h4>

                  <p>Your submission of personal information is governed by our Privacy Policy.</p>

                  <h4>SECTION 11 – ERRORS, INACCURACIES AND OMISSIONS</h4>

                  <p>We reserve the right to correct errors and update information at any time.</p>

                  <h4>SECTION 12 – PROHIBITED USES</h4>

                  <p>You are prohibited from using the site for unlawful, abusive, or malicious purposes.</p>

                  <h4>SECTION 13 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h4>

                  <p>
                    The Service is provided “as is” without warranties of any kind. We are not liable for any damages
                    arising from your use of the Service.
                  </p>

                  <h4>SECTION 14 – INDEMNIFICATION</h4>

                  <p>
                    You agree to indemnify and hold harmless Luxura Cart against claims arising from your breach of
                    these Terms.
                  </p>

                  <h4>SECTION 15 – SEVERABILITY</h4>

                  <p>If any provision is unenforceable, the remaining provisions shall remain valid.</p>

                  <h4>SECTION 16 – TERMINATION</h4>

                  <p>We may terminate these Terms at any time for violations.</p>

                  <h4>SECTION 17 – ENTIRE AGREEMENT</h4>

                  <p>These Terms constitute the entire agreement between you and us.</p>

                  <h4>SECTION 18 – GOVERNING LAW</h4>

                  <p>These Terms are governed by the laws of India.</p>

                  <h4>SECTION 19 – CHANGES TO TERMS OF SERVICE</h4>

                  <p>We reserve the right to update these Terms at any time.</p>

                  <h4>SECTION 20 – CONTACT INFORMATION</h4>

                  <div style={{ lineHeight: 2 }}>
                   <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: Host?.address,
                        }}
                      ></div>
                      <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                      &nbsp; {Host?.email} <br />
                    </p>
                  </div>

                  <p>Live Chat: Available on luxuracart.com during support hours</p>

                  <p>We will do our best to assist you while keeping your experience fair, transparent, and safe.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TermsConditions;
